<template>
  <div class="list" name="list">
    <el-card class="searchCard" shadow="never">
      <el-col>
        <el-form :inline="true" class="demo-inline-form" :model="search_sale">
          <el-form-item label="创建时间">
            <el-date-picker
              v-model="comeTime"
              type="daterange"
              align="left"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="dateChange"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="收银员账号"
              style="width:160px;"
              v-model="search_sale.FUserName"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="收银员姓名">
            <el-select
              style="width:120px;"
              clearable
              v-model="search_sale.FOperatorName">
              <el-option v-for="item in group_list" :key="item.keyone" :label="item.name" :value="item.name" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="收银员手机"
              style="width:150px;"
              v-model="search_sale.FMobile"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="账号状态">
            <el-select v-model="search_sale.FStatus" placeholder="状态" style="width:140px;" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="正常" value="0"></el-option>
              <el-option label="冻结" value="1"></el-option>
              <el-option label="注销" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="账号类型">
            <el-select v-model="search_sale.FUserType" placeholder="类型" style="width:140px;" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="店员" value="0"></el-option>
              <el-option label="店长" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <auth-button
              opt="search"
              icon="el-icon-search"
              :plain="true"
              @click.native="buttomSearch"
              :loading="checkLoading"
              label="查询"></auth-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <!-- 列表模块 -->
      <el-table
        stripe
        style="width:100%"
        align="center"
        v-loading="saleLoading"
        :data="sale_list"
        :header-cell-style="{background:'#FAFAFA'}"
        @sort-change="tableSortChange1"
      >
        <el-table-column
          prop="fCreateTime"
          label="创建时间"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="fUserName"
          label="收银员账号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fOperatorName"
          label="收银员姓名"
          align="center">
          <template slot-scope="scope">
            <div>{{ hideRealName(scope.row.fOperatorName) }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="fMobile"
          label="收银员手机"
          align="center">
          <template slot-scope="scope">
            <div>{{ hidePhoneNum(scope.row.fMobile) }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="fUserType"
          label="账号类型"
          :formatter="formatUserType"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fStatus"
          label="状态"
          :formatter="formatStatus"
          align="center">
        </el-table-column>
        <el-table-column
          label="操作"
          width="300"
          align="center"
          fixed="right"
          :context="_self">
          <template slot-scope="scope">
            <auth-button
              opt="edit"
              type="text"
              v-if="scope.row.fStatus !== 2"
              label="编辑"
              @click.native="handleEdit(scope.row,scope.$index,sale_list)"></auth-button>
            <auth-button
              opt="freeze"
              type="text"
              v-if="scope.row.fStatus !== 2"
              v-show="scope.row.fStatus !== 1"
              prop="fStatus"
              label="冻结"
              @click.native="handleFreeze(scope.row,scope.$index,sale_list)"></auth-button>
            <auth-button
              opt="unfreeze"
              type="text"
              v-if="scope.row.fStatus === 1"
              prop="fStatus"
              label="解冻"
              @click.native="handleFreeze(scope.row,scope.$index,sale_list)"></auth-button>
            <auth-button
              opt="delete"
              type="text"
              label="删除"
              v-if="scope.row.fStatus !== 2"
              @click.native="onDeleteUser(scope.row,scope.$index,sale_list)"></auth-button>
            <el-button
              type="text"
              v-if="scope.row.fStatus === 2"
              prop="fStatus"
              disabled
            >该用户已删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-col :span="24" class="btm-action">
      <el-pagination
        v-if="paginations.total>0"
        class="pagination"
        :page-sizes="paginations.pageSizes"
        :page-size="paginations.pageSize"
        :layout="paginations.layout"
        :total="paginations.total"
        :pageNum="paginations.pageNum"
        @current-change="onChangeCurrentPage">
      </el-pagination>
    </el-col>
    <!-- <el-button :plain="true" @click="openMess">重置密码成功，默认为: Aa123456</el-button> -->

    <!-- 编辑收银员界面 -->
    <el-dialog title="" :visible.sync="editOperatorVisible" size="small" @close="closeViewDialog">
      <el-form>
        <el-row>
          <el-form
            label-width="200px"
            ref="basic"
            :model="basic"
            :rules="rule_data">
            <h4>收银员信息修改</h4>
            <el-form-item label="登录账号" prop="cashierAccount">
              <el-input v-model="basic.cashierAccount" clear style="width:40%;" placeholder="8-20位数字或字母" disabled></el-input>
            </el-form-item>
            <!-- <el-form-item label="登录密码" prop="password">
                    <el-input v-model="basic.password" type="password" clear style="width:40%;" placeholder="不填默认为：Aa123456"></el-input>
                </el-form-item> -->
            <el-form-item label="收银员姓名" prop="cashierName">
              <el-input v-model="basic.cashierName" clear style="width:40%;" @focus="needHideInfoInputFocus('cashierName')"></el-input>
            </el-form-item>
            <el-form-item label="收银员手机" prop="mobile">
              <el-input v-model="basic.mobile" clear style="width:40%;" @focus="needHideInfoInputFocus('mobile')"></el-input>
            </el-form-item>
            <el-form-item label="员工类型" prop="userType">
              <el-select v-model="basic.userType" placeholder="员工类型" style="width:150px;">
                <el-option label="店员" :value="0"></el-option>
                <el-option label="店长" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer" style="width:100%">
        <el-button @click="editOperatorVisible = false">取 消</el-button>
        <el-button icon="el-icon-edit" type="primary" @click="editSubmit" :loading="editLoading">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import { hideRealName, hidePhoneNum } from '@/utils/hideSensitiveInfo.js'
import { cashierDetail, resetSubCashier, freezeCashier, unfreezeCashier, deleteCashier, listCashierAc, cashierName, updateCashierAc } from '@/api/cashier.js'
import md5 from 'js-md5'
import { validStrictPsd, strictPsdError } from '@/utils/validate.js'
export default {
  name: 'Info',
  data () {
    return {
      sale_list: [],
      group_list: [],
      domain: 'https://pos.yeahka.com/',
      table_type: 'sale',
      form_type: 'sale',
      salesNum: '',
      staffsNum: '',
      search_group_list: [],
      comeTime: '',
      downCtr: true,
      editOperatorVisible: false,
      editLoading: false,
      totaldata: {},
      fCreateTime: '',
      fUserName: '',
      fOperatorName: '',
      fMobile: '',
      // 搜索表单信息
      search_sale: {
        startTime: '',
        endTime: '',
        FUserName: '',
        FMobile: '',
        FOperatorName: '',
        FStatus: '',
        FUserType: '',
        pageNo: '',
        pageSize: '',
        totalCount: ''
      },
      basic: {
        cashierAccount: '',
        password: '',
        cashierName: '',
        mobile: '',
        userType: ''
      },
      fStatus: '',
      saleLoading: false,
      staffLoading: false,
      checkLoading: false,
      groupIdDisabledInput: false,
      disabledInput: false,
      dataParam: {},
      // 弹框信息
      addSale: {
        show: false,
        flag: false
      },
      // 需要给分页组件传的信息
      paginations: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
        pageSizes: [10],
        layout: 'total, prev, pager, next, jumper'
      },
      seloading: false,
      accesss: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      props: {
        label: 'name',
        value: 'name',
        children: 'children'
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      rule_data: {
        cashierAccount: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('账号不能空'))
            } else {
              if (/^[a-zA-Z0-9]{8,20}$/.test(value)) {
                callback()
              } else {
                callback(new Error('请输入正确的账号格式'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        password: [{
          validator: (rule, value, callback) => {
            if (validStrictPsd(value)) {
              callback()
            } else {
              return callback(new Error(strictPsdError))
            }
          },
          required: true,
          trigger: 'blur'
        }],
        cashierName: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入真实姓名'))
            } else {
              if (/^[\u4E00-\u9FA5A-Za-z0-9]{2,20}$/.test(value) || value.includes('*')) {
                callback()
              } else {
                callback(new Error('长度在2到20之间,且只能包含数字、字母、汉字.'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        mobile: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入手机号码'))
            } else {
              if (!(/^\d{11,11}$/.test(value)) && !value.includes('*')) {
                callback(new Error('请输入11位手机号码'))
              } else {
                callback()
              }
            }
          }
        }]
      }
    }
  },
  methods: {
    /**
       * hideRealName方法提供给页面调用
       */
    hideRealName (phone) {
      return hideRealName(phone)
    },
    /**
       * hidePhoneNum方法提供给页面调用
       */
    hidePhoneNum (phone) {
      return hidePhoneNum(phone)
    },
    handleEdit (row, index) {
      this.editOperatorVisible = true
      this.basic.cashierAccount = row.fUserName
      var data = {
        FUserName: row.fUserName
      }
      data = qs.stringify(data)
      cashierDetail(data).then(data => {
        if (parseInt(data.error_code) === 0) {
          this.basic.password = data.data.fUserPassword
          this.basic.cashierName = data.data.fOperatorName
          this.basic.realcashierName = this.basic.cashierName
          this.basic.cashierName = hideRealName(this.basic.cashierName)
          this.basic.mobile = data.data.fMobile
          this.basic.realmobile = this.basic.mobile
          this.basic.mobile = hidePhoneNum(this.basic.mobile)
          this.basic.userType = data.data.fUserType
        } else {
          this.$message({
            message: data.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
       * 需要隐藏信息的输入框获取焦点
       */
    needHideInfoInputFocus (type) {
      if (this.basic[type]) {
        this.basic[type] = ''
        this.basic[`real${type}`] = ''
      }
    },
    // 编辑
    editSubmit () {
      var that = this
      var pw = this.basic.password
      if (pw && pw.length >= 32) {
        this.basic.password = ''
      }
      this.basic.mobile = that.basic.realmobile || that.basic.mobile
      this.basic.cashierName = that.basic.realcashierName || that.basic.cashierName

      that.$confirm('确认提交吗？', '提示', {}).then(() => {
        that.editLoading = true
        let para = Object.assign({}, this.basic)
        para = JSON.parse(JSON.stringify(para))
        if (pw && pw.length < 32) { para.password = md5(pw) }
        para = qs.stringify(para)
        updateCashierAc(para).then(data => {
          that.editLoading = false
          if (parseInt(data.error_code) === 0) {
            that.$message({
              message: data.error_msg,
              type: 'success'
            })
            that.getList()
            that.editLoading = false
            this.editOperatorVisible = false
          } else {
            that.$message({
              showClose: true,
              message: data.error_msg,
              type: 'error'
            })
            that.editLoading = false
          }
        })
      })
    },
    deleteValid (v) {
      if (v) {
        if (this.table_type === 'sale') {
          this.$refs.addSaleForm.validateField('masterChannelId')
        } else {
          this.$refs.addStaffForm.validateField('masterChannelId')
        }
      }
    },
    dateChange (value) {
      if (value !== null) {
        value[0] = value[0].getFullYear() + '-' + (((value[0].getMonth() + 1) < 10) ? ('0' + (value[0].getMonth() + 1)) : (value[0].getMonth() + 1)) + '-' + ((value[0].getDate() < 10) ? ('0' + value[0].getDate()) : (value[0].getDate())) + ' 00:00:00'
        value[1] = value[1].getFullYear() + '-' + (((value[1].getMonth() + 1) < 10) ? ('0' + (value[1].getMonth() + 1)) : (value[1].getMonth() + 1)) + '-' + ((value[1].getDate() < 10) ? ('0' + value[1].getDate()) : (value[1].getDate())) + ' 23:59:59'
        this.search_sale.startTime = value[0]
        this.search_sale.endTime = value[1]
      } else {
        this.search_sale.startTime = ''
        this.search_sale.endTime = ''
      }
    },
    handleClick () {
      this.getList()
    },
    transferType (index, row) {
      this.$confirm('转职成功后将不可修改, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.dynamicTags.splice(this.dynamicTags.indexOf('tag'), 1)
        this.$message({
          type: 'success',
          message: '转职成功!'
        })
      })
    },
    // 显示编辑界面
    handleSale (index, row, scope) {
      // this.disabledInput = true;
      this.viewSale.show = true
      this.getRow(row.f_account_id)
      // this.editSaleForm = Object.assign({}, row);
      // delete this.editSaleForm["f_create_time"];
      // delete this.editSaleForm["f_update_time"];
    },
    handleStaff (index, row) {
      this.viewStaff.show = true
      this.getRow(row.f_account_id)
    },
    tableSortChange1 (val) {
      if (val.prop !== null) {
        if (val.order === 'descending') {
          this.search_sale.orderColumn = val.prop
          this.search_sale.orderType = 1
        } else {
          this.search_sale.orderColumn = val.prop
          this.search_sale.orderType = 0
        }
      }
      this.getList()
    },
    closeViewDialog () {
      this.downCtr = true
      // this.$refs['editStaffForm'].resetFields();
    },
    closeDialog () {
      // this.$refs['addStaffForm'].resetFields();
    },
    showViewSDialog () {
      // this.$refs['editStaffForm'].resetFields();
      // this.$refs.editSaleForm.resetFields();
    },
    showViewDialog () {
      // this.$refs['editStaffForm'].resetFields();
      // this.$refs.editStaffForm.resetFields();
      this.viewStaff.flag = true
    },
    showDialog () {
      this.viewStaff.flag = true
    },
    showAddSale () {
      // this.$refs.addSaleForm.resetFields();
    },
    showAddStaff () {
      // this.$refs.addStaffForm.resetFields();
    },
    handleChange (value) {
      this.getFBankAreaPrvince(value)
    },
    setBankName (value) {
      if (this.addStaff.show && !this.addStaff.flag) {
        this.addStaffForm.f_bank_address = ''
        // this.addStaff.flag = false;
      } else if (this.viewStaff.show && !this.viewStaff.flag) {
        this.editStaffForm.f_bank_address = ''
        // this.viewStaff.flag = false;
      }
      let obj = {}
      obj = this.bank_list.find((item) => {
        return item.F_bank_name === value
      })
      if (this.addStaff.show && obj) {
        this.addStaffForm.f_bank_code = obj.F_bank_name_code
        if (this.addStaffForm.f_bank_code && this.addStaffForm.f_bank_city_code) {
          this.getBranchList()
        }
      } else if (this.viewStaff.show && obj) {
        this.editStaffForm.f_bank_code = obj.F_bank_name_code
        if (this.editStaffForm.f_bank_code && this.editStaffForm.f_bank_city_code) {
          this.getBranchList()
        }
      }
      this.addStaff.flag = false
      this.viewStaff.flag = false
    },

    initRouters () {
      // this.$router.push("/saleManager/sales");
      var routes = this.$router.options.routes
      for (var i = 0; i < routes.length; i++) {
        if (routes[i].hidden !== true && routes[i].children && routes[i].children.length) {
          var tempObj = {}
          var module = routes[i]
          var menus = module.children
          tempObj.name = module.name
          tempObj.path = module.path
          tempObj.access = module.path
          tempObj.children = []
          var menuLen = menus.length
          for (var j = 0; j < menuLen; j++) {
            if (menus[j].hidden !== true && menus[j].children && menus[j].children.length) {
              var tempChildObj = {}
              var menu = menus[j]
              var pages = menu.children
              tempChildObj.name = menu.name
              tempChildObj.path = '/' + menu.path
              tempChildObj.access = tempObj.path + '/' + menu.path
              tempChildObj.children = []
              var pagesLen = pages.length
              for (var k = 0; k < pagesLen; k++) {
                if (pages[k].hidden !== true) {
                  var tempPageObj = {}
                  var page = pages[k]
                  tempPageObj.name = page.name
                  tempPageObj.path = '/' + page.path
                  tempPageObj.access = tempObj.path + '/' + menu.path + '/' + page.path
                  tempChildObj.children.push(tempPageObj)
                }
              }
              tempObj.children.push(tempChildObj)
            }
          }
          this.accesss.push(tempObj)
        }
      }
    },
    toQueryPair (key, value) {
      if (typeof value === 'undefined') {
        return key
      }
      return key + '=' + encodeURIComponent(value === null ? '' : String(value))
    },
    toQueryString (obj) {
      var ret = []
      var that = this
      for (var key in obj) {
        key = encodeURIComponent(key)
        var values = obj[key]
        if (values && values.constructor === Array) { // 数组
          var queryValues = []
          for (var i = 0, len = values.length, value; i < len; i++) {
            value = values[i]
            queryValues.push(that.toQueryPair(key, value))
          }
          ret = ret.concat(queryValues)
        } else { // 字符串
          ret.push(that.toQueryPair(key, values))
        }
      }
      return ret.join('&')
    },
    /**
       * 点击搜索按钮事件
       */
    onSearch () {
      // this.search_sale.pageNo='';
      // this.search_sale.pageSize = '';
      // this.search_sale.totalCount = '';
      // this.search_sale.Count = '';

      this.checkLoading = true
      this.getList()
    },
    /* 点击查询按钮事件 */
    buttomSearch () {
      // 当点击查询时，显示第一页
      this.search_sale.pageNo = 1
      // 让页码数回归到1
      this.paginations.total = 0
      this.onSearch()
    },
    /**
       * 改变页码和当前页时需要拼装的路径方法
       * @param {string} field 参数字段名
       * @param {string} value 参数字段值
       */
    setPath (field, value) {
      var path = this.$route.path
      var query = Object.assign({}, this.$route.query)

      query[field] = value

      this.$router.push({
        path: path,
        query: query
      })
    },
    formatUserType (item) {
      return item.fUserType === 0 ? '店员' : '店长'
    },
    formatStatus (item) {
      return item.fStatus === 0 ? '正常' : (item.fStatus === 1 ? '冻结' : '注销')
    },
    freeStatus (item) {
      if (item.fStatus === 1) {
        this.$jquery(this).removeClass('dsn')
      }
    },
    unfreeStatus (item) {
      if (item.fStatus === 0) {
        this.$jquery(this).removeClass('dsn')
      }
    },
    /**
       * 改变当前页事件
       * @param  {number} page 当前页码
       */
    onChangeCurrentPage (page) {
      var totalCount = this.salesNum
      // var pageSize = this.sale_list.length;
      this.search_sale.pageNo = page
      this.search_sale.pageSize = this.paginations.pageSize
      this.search_sale.Count = totalCount
      this.onSearch()
    },

    /**
       * 改变每页显示数量事件
       * @param  {number} size 当前每页显示数量
       */
    onChangePageSize (size) {
      console.log(this)
      var totalCount = this.salesNum
      var pageNo = this.paginations.pageNum
      this.search_sale.pageSize = size
      this.search_sale.pageNo = pageNo
      this.search_sale.Count = totalCount
      this.onSearch()
    },
    /**
      * 重置密码事件
      */
    handleReset (user, index, list) {
      var id = user.fUserName
      var data = { FUserName: id }
      data = qs.stringify(data)
      this.$confirm('你确认重置用户 ' + user.fOperatorName + ' 的登录密码为：Aa123456 吗?', '重置密码', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        resetSubCashier(data).then(data => {
          if (user === true) {
            this.sale_list = this.sale_list.filter(function (item, idx) {
              return id.indexOf(item.fUserName) === -1
            })
          } else {
            list.splice(index, 1)
          }
          // this.$message('密码重置成功，默认为：Aa123456');
          this.getList()
        })
      })
    },
    /*
      * 冻结/解冻事件
      */
    handleFreeze (user, index, list) {
      var id = user.fUserName
      var data = { FUserName: id }
      data = qs.stringify(data)
      var fStatus = user.fStatus
      if (fStatus === 0) {
        this.$confirm('你确认冻结用户 ' + user.fOperatorName + ' 么?', '冻结用户', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          freezeCashier(data).then(data => {
            if (user === true) {
              this.sale_list = this.sale_list.filter(function (item, idx) {
                return id.indexOf(item.fUserName) === -1
              })
            } else {
              list.splice(index, 1)
            }
            this.getList()
          })
        })
      } else {
        this.$confirm('你确认解冻用户 ' + user.fOperatorName + ' 么?', '解冻用户', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          unfreezeCashier(data).then(data => {
            if (user === true) {
              this.sale_list = this.sale_list.filter(function (item, idx) {
                return id.indexOf(item.fUserName) === -1
              })
            } else {
              list.splice(index, 1)
            }
            this.getList()
          })
        })
      }
    },
    /**
       * 注销用户事件
       * @param  {object || boolean} user  当前用户信息对象或者为布尔值,为布尔值时，代表是批量删除
       * @param  {number} index 当前用户列表索引
       * @param  {array} list  当前用户列表数组
       */
    onDeleteUser (user, index, list) {
      var id = user.fUserName
      var data = { FUserName: id }
      data = qs.stringify(data)
      this.$confirm('你确定注销用户 ' + user.fOperatorName + ' 么?', '注销用户', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteCashier(data).then(data => {
          if (user === true) {
            this.sale_list = this.sale_list.filter(function (item, idx) {
              return id.indexOf(item.fUserName) === -1
            })
          } else {
            list.splice(index, 1)
          }
          this.getList()
        })
      })
    },
    /**
       * 增加业务员
       * @param
       */
    onAdd () {
      if (this.table_type === 'sale') {
        this.addSale.show = true
      } else {
        this.addStaff.show = true
        this.addStaff.selectedOptions = []
        this.bankbranch_list = []
      }
    },
    // 获取编辑业务员信息
    // getRow(id) {
    //   this.$$api_sales_selectUser({
    //       f_account_id: id
    //     },
    //     (data) => {
    //       if (data.code !== 0) {
    //         if (data.message.indexOf("登录超时") !== -1) {
    //           this.$store.dispatch('remove_userinfo').then(() => {
    //             this.$router.push('/login');
    //           });
    //         } else {
    //           this.$message({
    //             showClose: true,
    //             message: data.error_msg,
    //             type: 'error'
    //           });
    //         }
    //       } else {
    //         if (this.table_type === 'sale') {
    //           this.editSaleForm = data.data[0];
    //           var s = this.editSaleForm["f_job_position"] === null ? '' : this.editSaleForm["f_job_position"].toString();
    //           var ss = this.editSaleForm["f_status"] === null ? '' : this.editSaleForm["f_status"].toString();
    //           // var sss = this.editSaleForm["f_group_id"] === null ? '' : this.editSaleForm["f_group_id"].toString();
    //           this.editSaleForm["f_job_position"] = s;
    //           this.editSaleForm["f_status"] = ss;
    //           // this.editSaleForm["f_group_id"] = 13;
    //           delete this.editSaleForm["f_create_time"];
    //           delete this.editSaleForm["f_update_time"];
    //           delete this.editSaleForm["unionChannelIdList"];
    //           delete this.editSaleForm["accountStatus"];
    //           this.createImg(this.editSaleForm.masterChannelId);
    //         } else {
    //           this.editStaffForm = data.data[0];
    //           this.viewStaff.selectedOptions = [];
    //           this.bankbranch_list = [];
    //           if (this.editStaffForm.f_real_name) {
    //             this.editStaffForm.f_bank_card_onwer = this.editStaffForm.f_real_name;
    //           }
    //           if (this.editStaffForm.f_bank_info && !this.editStaffForm.f_bank_code) {
    //             let obj = {};
    //             obj = this.bank_list.find((item) => {
    //               return item.F_bank_name === this.editStaffForm.f_bank_info;
    //             });
    //             if (obj) { this.editStaffForm.f_bank_code = obj.F_bank_name_code; } else { this.editStaffForm.f_bank_info = ""; }
    //           }
    //           if (this.editStaffForm.f_bank_province && this.editStaffForm.f_bank_city) {
    //             this.viewStaff.selectedOptions = [this.editStaffForm.f_bank_province, this.editStaffForm.f_bank_city];
    //             this.getFBankAreaPrvince(this.viewStaff.selectedOptions);
    //           }
    //           delete this.editStaffForm["f_create_time"];
    //           delete this.editStaffForm["f_update_time"];
    //           delete this.editStaffForm["unionChannelIdList"];
    //           delete this.editStaffForm["accountStatus"];
    //           this.createImg(this.editStaffForm.masterChannelId);
    //         }
    //       }
    //     }
    //   )
    // },
    formatSearch (search) {
      var data = Object.assign({}, search)
      for (var s in data) {
        if (!data[s] && data[s] !== 0) {
          delete data[s]
        }
      }
      return data
    },
    /**
       * 获取用户信息列表方法
       */
    getList () {
      this.saleLoading = true
      var data = this.formatSearch(this.search_sale)
      data = qs.stringify(data)

      listCashierAc(data).then(data => {
        this.checkLoading = false
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
          this.saleLoading = false
        } else {
          this.saleLoading = false
          this.paginations.total = data.data.totalCount
          this.sale_list = data.data.list
          this.salesNum = data.data.totalCount
          // this.group_list = data.date.grouplist;
        }
      })
    },
    getGroup () {
      cashierName('').then((data) => {
        if (parseInt(data.error_code) !== 0) {
        } else {
          this.group_list = data.list
        }
      })
    }
  },
  mounted () {
    this.getList()
    this.getGroup()
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .demo-form-inline {
        display: inline-block;
        float: right;
    }

    .btm-action {
        margin: 20px 0;
        text-align: center;
    }

    .pagination {
        display: inline-block;
    }
    .list{
        padding-left: 16px;
    }
    .tab-tag{
      height:0;
      padding: 0;
      line-height: 0;
      background: transparent;
    }
    .dsn{
        display: none;
    }
.el-button .el-button {
    margin-left: 4px;
}
</style>
